<script lang="ts">import { Button } from "@infinitro/button";
import { t, Verbiage } from "@infinitro/content";
import { isMobile, isTablet, ModalDialog, pushModal } from "@infinitro/global";
import { Text } from "@infinitro/text";
import { onMount } from "svelte";
export let backgroundImage;
export let backgroundImageMobile;
export let title;
export let description;
export let bonusAmount;
export let numberOfDeposits;
const safe = (v) => v === undefined || v === null ? "" : String(v);
const handleSignup = () => {
	pushModal(ModalDialog.Auth, { tab: "signup" });
};
$: isPhone = $isMobile && !$isTablet;
$: formattedDescription = $t(description).replace(/\s*\+\s*/g, "<br/>").replaceAll("[BONUS_AMOUNT]", safe(bonusAmount)).replaceAll("[NUMBER_OF_DEPOSITS]", safe(numberOfDeposits)).replace(/\s{2,}/g, " ").trim();
</script>

<div class="big-card-public">
	<img src={backgroundImage} alt={title} class="big-card-bg" />
	<div class="big-card-content">
		<h3 class="big-card-title">
			{@html $t(title)
				.split(' ')
				.map((w) => `<span>${w}</span>`)
				.join(' ')}
		</h3>
		{#key `${$isMobile}-${$isTablet}`}
			<Text
				type="subtitle"
				subtitleSize={isPhone ? 'medium' : 'large'}
				subtitleWeight="extrabold"
				customStyle="
		font-weight: 800;
		font-size: {isPhone ? '12px' : '20px'};
		line-height: {isPhone ? '16px' : '22px'};
	"
			>
				{@html formattedDescription}
			</Text>
			<Button
				variant="primary"
				text={$t(Verbiage.register)}
				size={isPhone ? 'small' : 'large'}
				width={isPhone ? '50%' : '40%'}
				onClick={handleSignup}
			/>
		{/key}
	</div>
</div>

<style>
	.big-card-public {
		position: relative;
		height: auto;
		min-height: 150px;
		width: 100%;
		overflow: hidden;
		border-radius: 12px;
		aspect-ratio: 60 / 25;
}

	.big-card-public::before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		border-radius: 12px;
		padding: 1px;
		background: linear-gradient(
			180deg,
			rgba(var(--color-primary-500-rgb) / 0.9) 0%,
			rgba(255, 255, 255, 0) 100%
		);
		-webkit-mask:
			linear-gradient(#fff 0 0) content-box,
			linear-gradient(#fff 0 0);
		-webkit-mask-composite: xor;
		mask-composite: exclude;
		pointer-events: none;
		z-index: 1;
	}

	.big-card-bg {
		position: absolute;
		height: 100%;
		width: 100%;
		-o-object-fit: cover;
		   object-fit: cover;
		top: 0;
		left: 0;
		z-index: 0;
}

	.big-card-content {
		position: relative;
		display: flex;
		height: 100%;
		min-height: 150px;
		flex-direction: column;
		justify-content: space-between;
		padding: 1rem;
		z-index: 2;
}

	.big-card-title {
		max-width: 50%;
		color: var(--color-text-100);
		font-family: var(--font-main);
		font-size: 28px;
		font-weight: 900;
		line-height: 24px;
		letter-spacing: -0.2px;
}

	@media (min-width: 640px) {
		.big-card-content {
				justify-content: space-around;
		}
		.big-card-title {
			font-size: 54px;
			line-height: 45px;
		}
		.big-card-public {
			aspect-ratio: 75 / 25;
		}
	}

	@media (min-width: 1024px) {
		.big-card-content {
				justify-content: space-between;
			padding: 24px;
		}
		.big-card-title {
			font-size: 54px;
			line-height: 45px;
		}
		.big-card-public {
			aspect-ratio: 60 / 25;
		}
	}
</style>
